import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "top-tip-wrap flex justify-between"
}
const _hoisted_2 = { class: "top-tip-text" }

import { storeToRefs } from 'pinia';
import { useSettingsStore } from '@/store'


export default {
  __name: 'TopTip',
  setup(__props) {

const settingsStore = useSettingsStore()
const { showTopTip } = storeToRefs(settingsStore);

return (_ctx, _cache) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _directive_audio = _resolveDirective("audio")

  return (_unref(showTopTip))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('msg.useGoogle')), 1),
        _withDirectives(_createVNode(_component_van_icon, {
          class: "close-icon",
          name: "clear",
          onClick: _cache[0] || (_cache[0] = $event => (_unref(settingsStore).hideTopTip()))
        }, null, 512), [
          [_directive_audio, void 0, "close"]
        ])
      ]))
    : _createCommentVNode("", true)
}
}

}